module.exports = __webpack_public_path__ + "img/warehouse-transfers.407dbb4a.png";